module.exports = "../../app/cells/components/banner/oab_disciplines_banner_cell.rb";